import { CheckBox, CheckBoxProps } from '@sharedUi/ui-kit/CheckBox';
import { MyLink } from '@app/shared';
import React, { forwardRef } from 'react';
import classNames from 'classnames';

import styles from './CustomCheckBox.module.scss';

interface CheckBoxReceiveNotificationsProps extends Omit<CheckBoxProps, 'children'> {
  reg?: any;
}

export const CheckBoxReceiveNotifications = forwardRef<HTMLInputElement, CheckBoxReceiveNotificationsProps>(
  ({ id, className, ...props }, ref): JSX.Element => {
    return (
      <CheckBox className={classNames(styles.Wrapper, className)} id={id} data-testid="checkbox-receive-notifications" ref={ref} {...props}>
        <div className={styles.Text}>Хочу получать информацию о&nbsp;</div>
        <MyLink target="_blank" href="/pages/view/soglasierekl/" rel="noreferrer">
          товарах и акциях
        </MyLink>
      </CheckBox>
    );
  },
);

CheckBoxReceiveNotifications.displayName = 'CheckBoxReceiveNotifications';
